import styled from 'styled-components';

import InputStyles from './InputStyles';

const Input = styled.input`
    ${InputStyles};
`;

export default Input;
